// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__agzam","open-overlay":"Overlay_open-overlay__FUMVo","clear":"Overlay_clear__WsaYE"};